import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import "./index.css";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

console.log("GOOGLE CLIENT ID =", CLIENT_ID);

if (!CLIENT_ID) {
  console.error("Missing REACT_APP_GOOGLE_CLIENT_ID in frontend/.env");
}


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <GoogleOAuthProvider clientId={CLIENT_ID}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </GoogleOAuthProvider>
);

